import { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, CircularProgress, Menu, MenuItem, ListItemText } from '@mui/material';
import { Download as DownloadIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import useGatewayContagem from '../../Context/Hooks/useGatewayContagem';
import { exportAPI } from '../../API/exportAPI';

const DataExportButton = ({ clientId, startDate, endDate, storeId }) => {
  const { t, i18n } = useTranslation();
  const { selectedClient, selectedStore } = useGatewayContagem();
  const [anchor, setAnchor] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleExport = async (type) => {
    setAnchor(null);
    setLoading(true);
    const clientName = selectedClient?.name || null;
    const storeName = (selectedStore && selectedStore.id === storeId) ? selectedStore.name : null;
    const lang = i18n.language || 'pt';
    try {
      if (type === 'countings') await exportAPI.exportCountings(clientId, startDate, endDate, storeId, clientName, storeName, lang);
      else if (type === 'dashboard') await exportAPI.exportDashboard(clientId, startDate, endDate, storeId, clientName, storeName, lang);
      else if (type === 'dwell') await exportAPI.exportDwellTime(clientId, startDate, endDate, storeId, clientName, storeName, lang);
      toast.success(t('common:export.success', 'Exportação iniciada — a transferir ficheiro'));
    } catch {
      toast.error(t('common:export.error', 'Erro ao exportar'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        startIcon={loading ? <CircularProgress size={16} /> : <DownloadIcon />}
        disabled={loading || !clientId}
        onClick={e => setAnchor(e.currentTarget)}
      >
        {t('dashboard:filters.export', 'Exportar')}
      </Button>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
      >
        <MenuItem onClick={() => handleExport('dashboard')}>
          <ListItemText
            primary={t('common:export.dashboard', 'Dashboard (.xlsx)')}
            secondary={t('common:export.dashboardDesc', 'Visão geral e tráfego diário')}
          />
        </MenuItem>
        <MenuItem onClick={() => handleExport('countings')}>
          <ListItemText
            primary={t('common:export.countings', 'Contagens (.xlsx)')}
            secondary={t('common:export.countingsDesc', 'Registos de contagem brutos')}
          />
        </MenuItem>
        <MenuItem onClick={() => handleExport('dwell')}>
          <ListItemText
            primary={t('common:export.dwellTime', 'Tempo de Permanência (.xlsx)')}
            secondary={t('common:export.dwellTimeDesc', 'Detalhes de permanência média')}
          />
        </MenuItem>
      </Menu>
    </>
  );
};

DataExportButton.propTypes = {
  clientId: PropTypes.string,
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  storeId: PropTypes.string,
};

export default DataExportButton;
